<script setup>
import BaseDialog from "@/base-components/Dialog/BaseDialog.vue";
import Button from "@/base-components/Button";
import {uri} from "@/constants/config.js";
import InputText from "@/base-components/Form/InputText.vue";
import {Form} from "vee-validate";
import {ref} from "vue";
import {object} from "yup";
import {useFetch} from "@/composables/useFetch.js";
import useValidate from "@/composables/useValidate.js";

const model = defineModel()
const props = defineProps({
  show: {
    type: Boolean,
    default: false
  }
})
const emits = defineEmits(['close'])

const loadingFlag = ref(false);

const form = ref({
  displayName: model.value.assigned.displayName || "",
})

const validationSchemaRegister = object(useValidate(['displayName']),)


async function onPost() {
  loadingFlag.value = true;
  try {
    // Await the result of useFetch
    const {data, error} = await useFetch(`${uri.admin.cloud.region.update}/${model.value.assigned.id}`, {body: form.value, method: "PATCH"});
    if (error) {
      return;
    }
    model.value.assigned = data
  } catch (err) {
    console.error(err.message || 'An unexpected error occurred.');
  } finally {
    loadingFlag.value = false;
    close()
  }
}

function close() {
  emits('close')

}

</script>

<template>
    <BaseDialog
        :size="'lg'"
        :open="show"
        :has-footer="true"
        :title="$t('button.update')"
        @close="close"
    >
      <Form class="w-full" id="editForm" :validation-schema="validationSchemaRegister" @submit="onPost">
        <div class="p-3">
          <InputText
              name="displayName"
              :has-label="true"
              :label="$t('label.displayName')"
              v-model="form.displayName"
              id="input-wizard-3"
              type="text"
          />
        </div>
      </Form>

      <template v-slot:footer>
        <free-style-shimmer width="100%" height="25px" class="w-full" v-if="loadingFlag"/>
        <div class="flex col-md-12 items-end justify-end gap-2" v-else>
          <Button variant="outline-secondary" @click="close" size="sm"
                  class="p-3 shadow-md justify-end items-end">
            {{ $t('button.cancel') }}
          </Button>
          <Button variant="primary" size="sm" form="editForm" class="p-3 shadow-md justify-end items-end">
            {{ $t('button.update') }}
          </Button>
        </div>
      </template>

    </BaseDialog>
</template>

<style scoped>

</style>